export default {
  placeholder: 'Wybierz użytkownika',
};
